import { toast } from "react-toastify";
import { downloadFile } from "../../services/fileServices";
import { handleErrors } from "../../services/handleErrors";
import { generatePDFRelevosDePerfilFromTemplate } from "../../services/relevoDePerfilServices";
import { generatePDFRelevoAdminFromTemplate } from "../../services/relevoAdministrativoServices";

export const handleClickFile = async ({ FileRels }, id) => {
  const { entity, entityId, fileId } = FileRels;

  // se pasa entity a string y se se cambia la primera letra por minuscula
  const stringEntity = entity.toString();
  const entityMinuscula = stringEntity.charAt(0).toLowerCase() + entity.slice(1);
  try {
    if (id) {
      const res = await downloadFile({ entity: entityMinuscula, entityId, fileId: id });
      if (res.error) throw res.error;
    } else {
      const res = await downloadFile({ entity: entityMinuscula, entityId, fileId });
      if (res.error) throw res.error;
    }
    toast.success("Archivo descargado");
  } catch (error) {
    toast.error("Error al descargar el archivo");
  }
  return true;
};

export const handleClickGeneratePdf = async (row, callback) => {
  let res;
  // Crea pdf relevo de perfil
  if (row.relsRelevoDePerfilSubcliente) {
    try {
      const { message, result } = await generatePDFRelevosDePerfilFromTemplate(row.id);
      toast.success(message);
      callback();
      res = result;
    } catch (error) {
      handleErrors(error, toast.error);
    }
  }

  // Crea pdf relevo administrativo
  if (row.relsRelevoAdministrativoSubcliente) {
    try {
      const { message, result } = await generatePDFRelevoAdminFromTemplate(row.id);
      toast.success(message);
      callback();
      res = result;
    } catch (error) {
      handleErrors(error, toast.error);
    }
  }

  return res;
};

export const configDatePickerLenguage = () => {
  const days = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"];
  const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

  const locale = {
    localize: {
      day: (n) => days[n],
      month: (n) => months[n],
      quarter: (n) => n,
    },
    formatLong: {
      date: () => "mm/dd/yyyy",
    },
  };

  return locale;
};

export function convertToTitleCase(camelCaseString) {
  return camelCaseString
    .replace(/([A-Z])/g, " $1") // Inserta un espacio antes de cada mayúscula
    .replace(/^./, (str) => str.toUpperCase()) // Convierte la primera letra en mayúscula
    .toLowerCase() // Convierte todo a minúscula
    .replace(/^./, (str) => str.toUpperCase()); // Convierte la primera letra en mayúscula nuevamente
}

/**
 * @typedef {Object} PI
 * @property {string | number} itemId - ID del PI
 * @property {string} titulo - Título del PI
 * @property {string} nombre - Nombre del PI
 */

/**
 * Obtiene el título y nombre de un PI a partir de su ID.
 *
 * @param {string | number} id - ID a buscar.
 * @param {PI[]} pis - Lista de objetos PI.
 * @returns {string} Concatenación del título y nombre o "-" si no se encuentra.
 */
export const getPiById = (id, pis) => {
  const pi = pis.find((objeto) => objeto.itemId === id);
  return pi ? `${pi.titulo} ${pi.nombre}` : "-";
};
